import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {
    CommunicationEventPurposeType,
    EditableStudentCommunicationEvent,
    StudentCommunicationEvent,
    StudentCommunicationEventProperties
} from '../../../model/student-communication-events';
import { MatPaginator } from '@angular/material/paginator';
import { CommunicationEventReportService } from 'src/app/component/child-reports/communication-event-report/service/communication-event-report.service';
import { StudentService } from '../../../service/student.service';
import { Student } from 'src/app/model/student/student.model';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { StudentCommunicationEventsService } from '../../../service/student-communication-events.service';
import { Subscription } from 'rxjs';
import { Msg } from 'src/app/component/auth/model/user.model';
import { StudentHelperService } from '../../../service/student-helper.service';
import { AccessService } from 'src/app/component/navigation/service/access.service';

@Component({
    selector: 'app-communication-table',
    templateUrl: './communication-table.component.html',
    styleUrls: ['./communication-table.component.scss']
})
export class CommunicationTableComponent implements OnInit {
    @Input() studentId!: number;
    @Input('studentCommunicationEvents') lstStudentCommunicationEvent: EditableStudentCommunicationEvent[];
    //@Input('communicationEventPurposeTypes') communicationEventPurposeTypes: CommunicationEventPurposeTypes[];

    @Input() editing: boolean;
    @Output() modificationEvent = new EventEmitter<string>();

    @ViewChild(MatPaginator) paginator: MatPaginator;
    editAccess: boolean = false;
    deleteAccess: boolean = false;
    displayedColumns: string[] = CommunicationEventColumns.filter(x => x.key != 'isEdit').map((col) => col.key);
    columnsSchema: any = CommunicationEventColumns.filter(x => x.key != 'isEdit');
    displayedColumnsEdit: string[] = CommunicationEventColumns.map((col) => col.key);
    columnsSchemaEdit: any = CommunicationEventColumns;

    communicationEventPurposeTypes: CommunicationEventPurposeType[];
    student: Student;
    isSaving: boolean = false;
    subs: Subscription[] = [];

    horizontalPosition: MatSnackBarHorizontalPosition = 'center';
    verticalPosition: MatSnackBarVerticalPosition = 'top';

    dataSource = new MatTableDataSource<EditableStudentCommunicationEvent>();

    constructor(
        //private studentService: StudentService,
        public studentHelperService: StudentHelperService,
        public sces: StudentCommunicationEventsService,
        public communicationEventReportService: CommunicationEventReportService,
        public accessService: AccessService,
        private msgBar: MatSnackBar
    ) { }

    ngOnInit(): void {

        this.accessService.featureAccessible('Edit Communication Events').subscribe(x => this.editAccess = x);
        //this.accessService.featureAccessible('Delete Communication Events').subscribe(x => this.deleteAccess = x);
        this.getCommunicationEventPurposeTypes();
        this.subscriptions();
    }
    ngOnChanges(): void {
        this.dataSource.data = JSON.parse(JSON.stringify(this.lstStudentCommunicationEvent));
        this.dataSource.paginator = this.paginator;
    }
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }

    //refactor to get it from ngrx store
    getCommunicationEventPurposeTypes() {
        this.accessService.getCommunicationEventPurposeType().subscribe((x) => {
            this.communicationEventPurposeTypes = x;

        });
        /*this.communicationEventReportService.getCommunicationEventPurposeTypes().subscribe((res) => {
            if (res.communicationEventPurposeTypes) {
                this.communicationEventPurposeTypes = res.communicationEventPurposeTypes;
            }
        });*/
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    subscriptions() {
        /*this.studentService.show(this.studentId).subscribe((res) => {
            if (res.student) {
                this.student = res.student;
            }
        });
        */
        let studentSub = this.studentHelperService.student$.subscribe((student) => {
            this.student = student;
        });

        this.subs.push(studentSub);
    }

    compareFn(o1: any, o2: any) {
        if (!o1 || !o2) {
            return false;
        }
        return o1?.ID === o2?.ID;
    }

    cEPPropertyTypes(element: EditableStudentCommunicationEvent, ob: MatCheckboxChange) {
        let selctedcommunicationPurposeType = this.communicationEventPurposeTypes.find(
            (x) => x.ID == element.studentCommunicationEvent.COMMUNICATION_EVENT_PURPOSE_TYPES.ID
        );

        if (ob.checked && element.studentCommunicationEvent.STUDENT_COMMUNICATION_EVENT_PROPERTIES.length <= 0) {
            element.studentCommunicationEvent.STUDENT_COMMUNICATION_EVENT_PROPERTIES[0] = new StudentCommunicationEventProperties();

            element.studentCommunicationEvent.STUDENT_COMMUNICATION_EVENT_PROPERTIES[0].COMMUNICATION_EVENT_PURPOSE_PROPERTY_TYPES_ID =
                selctedcommunicationPurposeType?.COMMUNICATION_EVENT_PURPOSE_PROPERTIES[0].COMMUNICATION_EVENT_PURPOSE_PROPERTY_TYPES_ID!;

            element.studentCommunicationEvent.STUDENT_COMMUNICATION_EVENT_PROPERTIES[0].COMMUNICATION_EVENT_PURPOSE_PROPERTY_TYPES =
                selctedcommunicationPurposeType?.COMMUNICATION_EVENT_PURPOSE_PROPERTIES[0].COMMUNICATION_EVENT_PURPOSE_PROPERTY_TYPES!;
        } else {
            element.studentCommunicationEvent.STUDENT_COMMUNICATION_EVENT_PROPERTIES = [];
        }
    }
    invokeDescription(element: EditableStudentCommunicationEvent): string {
        if (this.communicationEventPurposeTypes) {
            let str = this.communicationEventPurposeTypes.find((x) => x!.ID == element.studentCommunicationEvent?.COMMUNICATION_EVENT_PURPOSE_TYPES?.ID)
                ?.COMMUNICATION_EVENT_PURPOSE_PROPERTIES[0]?.COMMUNICATION_EVENT_PURPOSE_PROPERTY_TYPES?.DESCRIPTION;

            return str === undefined ? '' : str;
        } else return '';
    }

    matSelectEventchanged(element: EditableStudentCommunicationEvent) {
        element.studentCommunicationEvent.STUDENT_COMMUNICATION_EVENT_PROPERTIES = [];
    }

    disableSubmit(row: EditableStudentCommunicationEvent) {
        if (
            row.studentCommunicationEvent.COMMENTS != null &&
            row.studentCommunicationEvent.COMMUNICATION_EVENT_PURPOSE_TYPES.ID > 0 &&
            row.studentCommunicationEvent.COMMUNICATION_DATE != null
        ) {
            return false;
        } else return true;
    }

    statusReset(msg: string) {
        /*const s = timer(5000);
        s.subscribe((val) => {
            this.status = '';
        });*/

        this.msgBar.open(msg, '', {
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition,
            duration: 3000
        });
    }

    editRow(row: EditableStudentCommunicationEvent) {
        if (this.dataSource.data.findIndex((x) => x.isEdit == true) === -1) {
            row.isEdit = true;
        }
    }

    updateRow(row: EditableStudentCommunicationEvent) {
        if (row.studentCommunicationEvent.ID < 0) {
            //new CommunicationEventID
            row.studentCommunicationEvent.STUDENTS_ID = this.student.ID!;
            this.createStudentService(row);
        } else {
            /*if (this.lstEditSCommunicationEventId.indexOf(row.studentCommunicationEvent.ID) == -1)
                this.lstEditSCommunicationEventId.push(row.studentCommunicationEvent.ID!);*/
            this.updateStudentService(row);
        }
    }

    removeCommunicationEvent(row: EditableStudentCommunicationEvent) {
        if (this.dataSource.data.findIndex((x) => x.isEdit == true) === -1) {
            row.isEdit = true;
            row.isDelete = true;
        }
    }

    deleteRow(row: EditableStudentCommunicationEvent) {
        /*let id = row.studentCommunicationEvent.ID;
        let removedItem = this.dataSource.data.find((u: EditableStudentCommunicationEvent) => u.studentCommunicationEvent.ID == id);
        this.dataSource.data = this.dataSource.data.filter((u: EditableStudentCommunicationEvent) => u.studentCommunicationEvent.ID !== id);
        if (removedItem?.studentCommunicationEvent.ID! > 0) {
            this.lstEditSCommunicationEventId = this.lstEditSCommunicationEventId.filter((y) => y != id);
    	
            this.lstDeleteSCommunicationEventId.push(removedItem?.studentCommunicationEvent.ID!);
        }
        row.isEdit = false;
        row.isDelete = false;*/
        this.deleteStudentService(row);
    }

    cancelRow(row: EditableStudentCommunicationEvent) {
        //revert back to original state
        //get the original data from PhoneData and update the row else remove the data.
        let communicationEvent = this.lstStudentCommunicationEvent.find((x) => x.studentCommunicationEvent.ID === row.studentCommunicationEvent.ID);

        if (communicationEvent != undefined && communicationEvent.studentCommunicationEvent.ID! > 0) {
            row.studentCommunicationEvent = communicationEvent.studentCommunicationEvent;
            row.isEdit = false;
            row.isDelete = false;

            /*let itemIndex = this.lstEditSCommunicationEventId.indexOf(row.studentCommunicationEvent.ID);
            this.lstEditSCommunicationEventId = (itemIndex >= 0) ? this.lstEditSCommunicationEventId.filter((e, i) => i !== itemIndex) : this.lstEditSCommunicationEventId;*/
        } else {
            //this.dataSource.data = this.dataSource.data.filter((u: EditableStudentCommunicationEvent) => u.studentCommunicationEvent.ID !== row.studentCommunicationEvent.ID);
            this.modificationEvent.emit('cancelled');
        }
    }

    createStudentService(row: EditableStudentCommunicationEvent) {
        this.isSaving = true;

        if (row.studentCommunicationEvent.ID < 0) {
            let requestPayload: any = {};
            requestPayload.studentCommunicationEvent = row.studentCommunicationEvent;
            requestPayload.students = [this.student];
            this.sces.createStudentCommunicationEvents(requestPayload).subscribe((x) => {
                row.isEdit = false;
                row.isDelete = false;
                this.isSaving = false;
                let msg: Msg = x['msg'];
                if (msg.SUCCESS) {
                    this.statusReset('Created New Communication Event...');
                    this.modificationEvent.emit('created');
                }
            });
        }
    }

    updateStudentService(row: EditableStudentCommunicationEvent) {
        this.isSaving = true;
        let requestPayload: any = {};
        requestPayload.studentCommunicationEvent = row.studentCommunicationEvent;
        requestPayload.studentCommunicationEvents = [row.studentCommunicationEvent];
        this.sces.updateStudentCommunicationEvents(requestPayload).subscribe((x) => {
            row.isEdit = false;
            row.isDelete = false;
            this.isSaving = false;

            let msg: Msg = x['msg'];
            if (msg.SUCCESS) {
                this.statusReset('Successfully updated Communication Event...');
                this.modificationEvent.emit('modified');
            }
        });
    }

    deleteStudentService(row: EditableStudentCommunicationEvent) {
        this.isSaving = true;
        let requestPayload: any = {};
        requestPayload.studentCommunicationEvents = [row.studentCommunicationEvent];
        this.sces.deleteStudentCommunicationEvents(requestPayload).subscribe((x) => {
            this.isSaving = false;

            let msg: Msg = x['msg'];
            if (msg.SUCCESS) {
                this.statusReset('Successfully deleted Communication Event...');
                this.modificationEvent.emit('deleted');
            }
        });
    }
}

export const CommunicationEventColumns = [
    {
        key: 'isEdit',
        type: 'boolean',
        label: ''
    },
    {
        key: 'createdDate',
        type: 'date',
        label: 'Created'
    },
    {
        key: 'updated',
        type: 'text',
        label: 'Updated'
    },
    {
        key: 'communicationDate',
        type: 'date',
        label: 'Communication Date'
    },
    {
        key: 'communicationType',
        type: 'text',
        label: 'Communication Type'
    },
    {
        key: 'comments',
        type: 'text',
        label: 'Comments'
    },

];
